// extracted by mini-css-extract-plugin
export default {"details":"Details_details__lWPNO","detailsLeft":"Details_detailsLeft__e0Idd","detailsRight":"Details_detailsRight__iIaFe"};